import { h, render } from 'preact'
import { createPortal } from 'preact/compat';
import Modal from './components/Modal'
import PrivacySettingsLink from './components/PrivacySettingsLink'
import { StateProvider } from './context/Context';

// Create a new element to insert the entire UI into
const footerSelector = window.$mediavine.web.model.footer_selector
const modalRoot = document.createElement('div')
const privacySettingsRoot = document.createElement('div')
const privacySettingsTarget: HTMLElement = footerSelector
  && document.querySelector(footerSelector)
  || document.body

modalRoot.setAttribute('data-name', 'mediavine-gdpr-cmp')
modalRoot.setAttribute('data-nosnippet','1')
privacySettingsRoot.setAttribute('data-name', 'mediavine-gdpr-button')
privacySettingsRoot.setAttribute('data-nosnippet','1')

// Insert the modal and privacy settings link
document.body.insertAdjacentElement('beforeend', modalRoot)
privacySettingsTarget.insertAdjacentElement('beforeend', privacySettingsRoot)

/** 
 * createPortal lets us insert a component elsewhere
 * in the DOM while still being able to share state, hooks, etc.
 */ 
render(
  <StateProvider>
    <Modal />
    {createPortal(
      <PrivacySettingsLink />,
      privacySettingsRoot
    )}
  </StateProvider>,
  modalRoot
)
